module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAVCAYAAACzK0UYAAAACXBIWXMAAAsSAAALEgHS3X78AAAAzklEQVRIibXVsQ3DIBBA0W8rA3gCt7TOBJnCdewNMko2MD1TZIIkpVsm8AakCGkcS9yBfRISFPAEB1wVQkATxvkOuMehnfvWpubUKuEbDXCJbTLOD0cgy2qchNTI3LcvYNRAOTsh5kEMZSFaKBvRQEWIFCpGJFAVQsA4b4HrHuBGnGvj/O1AAKCpAQu8D0SW33E1QFe42MD/iYxz39pK+0FuRUzwtAXADrcrBRQjEqAIkQLZiAaA+BiVQAc8pQDkV0YxAHDKQBbgEfuiGv8BfKVqn6t4P+wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/reps_to_review_arrow.png
// module id = rmK5
// module chunks = 0